const Loading = () => {
  return (
    <div className="addItemNty">
      <div style={{ color: "white", textAlign: "center", paddingLeft: "45%" }}>
        Loading!
      </div>
    </div>
  );
};

export default Loading;
